import { fetchApi } from '@/config/axiosSetting.ts';
import {
  CreateZipVehiclePicturesResponseType,
  CreateZipVehiclePicturesZipType,
} from '@/modules/FileDetail/queries/documentation/createZip/createZipVehiclePictures/createZipVehiclePicturesQuery.type';

export const createZipVehiclePicturesQueryFunction = ({
  id,
  images_quality,
}: CreateZipVehiclePicturesZipType): Promise<CreateZipVehiclePicturesResponseType> =>
  fetchApi.get(`documents/${id}/file_images_zip/create/`, {
    params: { images_quality },
  });
